<template>
  <div>
    <QPageContainer>
      <QPage padding>
        <section v-if="skipped">
          <QIcon name="icon-extra-reward" size="100px" color="secondary" />
          <h2>{{ $t("ETAB.PAGES.SIGNUP.STEPS.@SKIPPED_TITLE") }}</h2>
          <h2>{{ $t("ETAB.PAGES.SIGNUP.STEPS.@SKIPPED_SUBTITLE") }}</h2>
        </section>
        <section v-else>
          <QIcon name="icon-extra-reward" size="100px" color="secondary" />
          <h2>{{ $t("ETAB.PAGES.SIGNUP.STEPS.@SUCCESS_TITLE") }}</h2>
          <h2>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.@SUCCESS_SUBTITLE")) }}</h2>
        </section>
      </QPage>
    </QPageContainer>

    <QFooter class="bg-transparent">
      <div>
        <QBtn color="secondary" class="full-width btn-navigation" :label="$t('ETAB.BUTTONS.@GO_TO_DASHBOARD')" no-caps @click="goToSmartHome" />
      </div>
    </QFooter>
  </div>
</template>

<script>
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { EtabProfileService } from "@core/services";

  import { GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { mapState } from "pinia";
  import { ETAB_ROUTES } from "@etab/config";

  export default {
    computed: {
      ...mapState(useSignupStore, {
        signupModel: GETTER_SIGNUP_GET,
      }),
      skipped() {
        return this.$route.query.skipped;
      },
      shouldUpdate() {
        return this.$route.query.update;
      },
    },
    created() {
      // we don't save if the user skipped the info steps
      if (this.shouldUpdate) {
        this.updateAdditionalInfo();
      }
    },

    methods: {
      goToSmartHome() {
        this.$router.push({ name: ETAB_ROUTES.smartRedirect.name }).catch((suppressedError) => {});
      },
      async updateAdditionalInfo() {
        try {
          this.$_startGlobalLoading();
          // additional info are under the responsability of the profile because the account is already created at this point
          await EtabProfileService.updateAdditionalInfo({ profile: this.signupModel });
          // remove the query in order to avoid the action on navigation back
          this.$router.replace({ ...this.$router.currentRoute, query: {} });
        } catch (error) {
          NotificationsManager.error({ message: "ERRORS.@UNSAVED_MODIFICATIONS" });
          throw error;
        } finally {
          this.$_stopGlobalLoading();
        }
      },
    },
  };
</script>
